export default function Presentation() {
  return (
    <section className="py-20 bg-gradient-to-br from-rose-50 via-white to-blush-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/e8256ac3a5aabb75efc7262b2aa071c0.jpg"
                alt="Technologie Perlée Froid"
                className="w-full h-auto rounded-3xl shadow-2xl"
              />
            </div>

            <div>
              <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-6">
                Comment ça <span className="font-semibold text-rose-500">fonctionne</span> ?
              </h2>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-rose-100 rounded-full flex-shrink-0">
                    <span className="text-lg font-bold text-rose-500">1</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Ionisation du gaz</h3>
                    <p className="text-gray-600">
                      Le Perlée froid est créé par l'ionisation d'un gaz, générant des particules chargées qui interagissent délicatement avec la peau.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-rose-100 rounded-full flex-shrink-0">
                    <span className="text-lg font-bold text-rose-500">2</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Application non-invasive</h3>
                    <p className="text-gray-600">
                      Aucune injection. Le Perlée est appliqué à la surface de la peau sans contact direct, respectant l'intégrité cutanée.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-rose-100 rounded-full flex-shrink-0">
                    <span className="text-lg font-bold text-rose-500">3</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Stimulation naturelle</h3>
                    <p className="text-gray-600">
                      Le Perlée interagit avec l'épiderme, stimulant les processus naturels pour améliorer l'apparence et la texture de la peau.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-6 bg-white rounded-xl border border-rose-100">
                <div className="flex items-center gap-3 mb-3">
                  <i className="ri-shield-check-line text-rose-500 text-2xl"></i>
                  <h4 className="font-semibold text-gray-900">Nos engagements</h4>
                </div>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-rose-500"></i>
                    Protocoles de sécurité stricts
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-rose-500"></i>
                    Équipements certifiés et professionnels
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-rose-500"></i>
                    Praticiens formés et expérimentés
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-rose-500"></i>
                    Suivi personnalisé de qualité
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
